<template>
  <div class="card-content">
    <!-- 环形分数显示 -->
    <Circle
      :current-rate="props.item.score * (100 / props.item.totalPoints)"
      size="50px"
      :text="props.item.score + '分'"
      :stroke-width="100"
      :color="CurrentColor(props.item.score * (100 / props.item.totalPoints))"
    />
    <div style="padding-left: 10px; width: 80%">
      <p class="titleColor"><strong>考试名称</strong></p>
      <p>{{ props.item.name }}</p>
      <p class="titleColor"><strong>考试时效</strong></p>
      <p>
        {{ props.item.started.split(" ")[0] }} -
        {{ props.item.expired.split(" ")[0] }}
      </p>
      <p>
        <Tag color="#f97675" class="Tag_">{{ props.item.duration }}分钟</Tag>
        <Tag color="#73cd83" class="Tag_">{{ props.item.peopleNums }}人</Tag>
        <Tag color="#5c96ed" class="Tag_">{{ props.item.totalSubjects }}题</Tag>
      </p>
    </div>
  </div>
</template>

<script setup>
import { defineProps } from "vue";
import { Circle, Tag } from "vant";
const props = defineProps({
  item: {
    name: String,
    score: Number,
    totalPoints: Number,
    started: String,
    expired: String,
    duration: Number,
    peopleNums: Number,
    totalSubjects: Number,
  },
});
// 计算环形进度条颜色
const CurrentColor = (score) => {
  if (score >= 80) {
    return {
      "0%": "#4de27c",
      "100%": "#4de27cc4",
    };
  } else if (score >= 60) {
    return {
      "0%": "#fba956",
      "100%": "#fba956c4",
    };
  } else if (score >= 40) {
    return {
      "0%": "#fb6b56",
      "100%": "#fb6b56bd",
    };
  } else {
    return {
      "0%": "#e82424",
      "100%": "#e82424bd",
    };
  }
};
</script>

<style scoped>
.Tag_ {
  margin-right: 5px;
  padding-top: 1px;
}
.card-content {
  display: flex;
  align-items: center;
}

.card-content .circle {
  margin-right: 10px;
}

.card-content p {
  font-size: 12px;
  text-align: left;
  margin: 5px 0;
  line-height: 1.1em;
}
.titleColor {
  color: #60ad80;
}
</style>
